// @TODO: Use Immer to reduce file line count
import { CertificateAction } from '../../actions/resources/Certificate';
import * as Constants from '../../constants/resources';
import initialState from '../../InitialState';
import { ApiStatus } from '../../types/api-status';
import { State } from '../../types/resources/State';

const certificate = (
  state: State = initialState,
  action: CertificateAction
): State => {
  switch (action.type) {
    case Constants.CERTIFICATES:
      return {
        ...state,
        certificate: {
          ...state.certificate,
          certificatesLoading: true
        }
      };
    case Constants.CERTIFICATES_SUCCESS:
      return {
        ...state,
        certificate: {
          ...state.certificate,

          certificates: {
            certificates: action.payload.certificates.certificates,
            total: action.payload.certificates.total
          },
          certificatesLoading: false
        }
      };
    case Constants.CERTIFICATES_FAILED:
      return {
        ...state,
        certificate: {
          ...state.certificate,
          certificates: {
            certificates: [],
            total: 0
          },
          certificatesLoading: false
        }
      };
    case Constants.CERTIFICATE_DETAIL:
      return {
        ...state,
        certificate: {
          ...state.certificate,
          selectedCertificate: {
            ...state.certificate.selectedCertificate,
            selectedCertificateLoading: true
          }
        }
      };
    case Constants.CERTIFICATE_DETAIL_SUCCESS:
      return {
        ...state,
        certificate: {
          ...state.certificate,
          selectedCertificate: {
            ...state.certificate.selectedCertificate,
            detail: action.payload.certificateDetail,
            selectedCertificateLoading: false
          }
        }
      };
    case Constants.CERTIFICATE_DETAIL_FAILED:
      return {
        ...state,
        certificate: {
          ...state.certificate,
          selectedCertificate: {
            ...state.certificate.selectedCertificate,
            selectedCertificateLoading: false
          }
        }
      };
    case Constants.CERTIFICATE_REFERENCES:
      return {
        ...state,
        certificate: {
          ...state.certificate,
          certificatesLoading: true
        }
      };
    case Constants.CERTIFICATE_REFERENCES_SUCCESS:
      return {
        ...state,
        certificate: {
          ...state.certificate,
          selectedCertificate: {
            ...state.certificate.selectedCertificate,
            references: action.payload.certificateReferences,
            selectedCertificateLoading: false
          }
        }
      };
    case Constants.CERTIFICATE_REFERENCES_FAILED:
      return {
        ...state,
        certificate: {
          ...state.certificate,
          selectedCertificate: {
            ...state.certificate.selectedCertificate,
            selectedCertificateLoading: false
          }
        }
      };
    case Constants.REPLACE_CERTIFICATE:
      return {
        ...state,
        certificate: {
          ...state.certificate,
          replaceCertificateStatus: ApiStatus.NotExecuted
        }
      };
    case Constants.REPLACE_CERTIFICATE_FAILED:
      return {
        ...state,
        certificate: {
          ...state.certificate,
          replaceCertificateStatus: ApiStatus.Error
        }
      };
    case Constants.REPLACE_CERTIFICATE_SUCCESS:
      return {
        ...state,
        certificate: {
          ...state.certificate,
          replaceCertificateStatus: ApiStatus.Completed
        }
      };
    default:
      return state;
  }
};

export default certificate;
